import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    // /search now declares search params (validateSearch); the redirect must
    // satisfy the resolved shape (mode has a default, so it's required here).
    throw redirect({ to: "/search", search: { mode: "keyword" } });
  },
});
